import React, { useState } from 'react';
import { B } from '../constants';
import Input from './ui/Input';
import { recapReels } from '../api';

export default function TripDayTracker({ days, dayLogs, selectedDay, setSelectedDay, logForm, setLogForm, onSaveLog, savingLog, trip }) {
  const [chartMetric, setChartMetric] = useState('steps');
  const totalDays = days?.length || 7;
  const totalSteps = dayLogs.reduce((s, l) => s + (l.steps || 0), 0);
  const totalDistance = dayLogs.reduce((s, l) => s + (l.distance || 0), 0);
  const daysLogged = dayLogs.filter(l => l.steps || l.distance || l.notes).length;

  const handleCreateReel = async (dayLog) => {
    if (!trip?.id || !dayLog?.id) return;
    try {
      await recapReels.create({ tripId: trip.id, dayLogId: dayLog.id });
      alert('Recap reel created! Check your reels to publish it.');
    } catch (err) {
      alert(err.message || 'Failed to create reel');
    }
  };

  const selectedLog = dayLogs.find(l => l.dayNumber === selectedDay);

  return (
    <div style={{ background: 'white', borderRadius: 16, padding: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
      <h3 style={{ marginBottom: 20, fontFamily: "'Montserrat',sans-serif", fontWeight: 700 }}>👣 Track Your Trip</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 16 }}>
        <div style={{ background: '#f8fcf9', borderRadius: 12, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 28 }}>👣</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: B.forest }}>{totalSteps.toLocaleString()}</div>
          <div style={{ fontSize: 12, color: B.muted }}>Total Steps</div>
        </div>
        <div style={{ background: '#f8fcf9', borderRadius: 12, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 28 }}>📏</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: B.forest }}>{totalDistance.toFixed(1)} km</div>
          <div style={{ fontSize: 12, color: B.muted }}>Total Distance</div>
        </div>
        <div style={{ background: '#f8fcf9', borderRadius: 12, padding: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 28 }}>📅</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: B.forest }}>{daysLogged}/{totalDays}</div>
          <div style={{ fontSize: 12, color: B.muted }}>Days Logged</div>
        </div>
      </div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: B.night, fontFamily: "'Montserrat',sans-serif" }}>Per-day breakdown</div>
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={() => setChartMetric('steps')} style={{ padding: '6px 12px', borderRadius: 50, border: 'none', background: chartMetric === 'steps' ? B.forest : '#f0f0f0', color: chartMetric === 'steps' ? 'white' : B.night, cursor: 'pointer', fontWeight: 600, fontSize: 12, fontFamily: "'Montserrat',sans-serif" }}>👣 Steps</button>
            <button onClick={() => setChartMetric('distance')} style={{ padding: '6px 12px', borderRadius: 50, border: 'none', background: chartMetric === 'distance' ? B.forest : '#f0f0f0', color: chartMetric === 'distance' ? 'white' : B.night, cursor: 'pointer', fontWeight: 600, fontSize: 12, fontFamily: "'Montserrat',sans-serif" }}>📏 Distance</button>
          </div>
        </div>
        {(() => {
          const daysArr = Array.from({ length: totalDays }, (_, i) => i + 1);
          const data = daysArr.map(dn => {
            const l = dayLogs.find(x => x.dayNumber === dn);
            if (chartMetric === 'steps') return { dayNumber: dn, value: l && l.steps ? Number(l.steps) : 0 };
            return { dayNumber: dn, value: l && l.distance ? Number(l.distance) : 0 };
          });
          const maxVal = Math.max(...data.map(d => d.value), 1);
          const totalVal = data.reduce((s, d) => s + (d.value || 0), 0);
          const daysWithData = data.filter(d => d.value > 0).length || 1;
          const avgVal = totalVal / daysWithData;
          const fmtVal = (v) => chartMetric === 'steps' ? (v >= 1000 ? Math.round(v).toLocaleString() : Math.round(v).toString()) : v.toFixed(1) + ' km';
          return (
            <div style={{ background: '#fafafa', borderRadius: 12, padding: 16 }}>
              <div style={{ overflowX: 'auto' }}>
                <div style={{ position: 'relative', minWidth: Math.max(daysArr.length * 36, 200) }}>
                  <div style={{ position: 'absolute', top: 14 + 14, left: 0, right: 0, height: 110, borderTop: '1px solid #eee', pointerEvents: 'none' }}>
                    <div style={{ position: 'absolute', top: -10, right: 0, fontSize: 9, color: B.muted, textAlign: 'right' }}>{fmtVal(maxVal)}</div>
                    {avgVal > 0 && avgVal <= maxVal && <div style={{ position: 'absolute', bottom: (avgVal / maxVal) * 100 + '%', left: 0, right: 0, borderTop: '1px dashed rgba(26,107,74,0.4)' }} />}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 0, paddingTop: 14, paddingBottom: 24 }}>
                    <div style={{ display: 'flex', gap: 10 }}>
                      {data.map(d => {
                        const isSelected = selectedDay === d.dayNumber;
                        return (
                          <div key={'call-' + d.dayNumber} style={{ flex: 1, minWidth: 24, maxWidth: 48, height: 14, fontSize: 10, color: isSelected ? B.forest : 'transparent', textAlign: 'center', whiteSpace: 'nowrap', fontWeight: isSelected ? 700 : 400 }}>
                            {isSelected && d.value > 0 ? (chartMetric === 'steps' ? d.value.toLocaleString() + ' steps' : d.value.toFixed(1) + ' km') : ''}
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, height: 110 }}>
                      {data.map(d => {
                        const pct = (d.value / maxVal) * 100;
                        const isSelected = selectedDay === d.dayNumber;
                        const barH = d.value > 0 ? Math.max(pct, 4) : 4;
                        return (
                          <div key={d.dayNumber} style={{ flex: 1, minWidth: 24, maxWidth: 48, height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                            <button
                              onClick={() => setSelectedDay(d.dayNumber)}
                              aria-label={'Day ' + d.dayNumber}
                              style={{
                                width: '100%',
                                height: barH + '%',
                                boxSizing: 'border-box',
                                background: d.value > 0 ? (isSelected ? '#145a3a' : B.forest) : '#e0e0e0',
                                border: isSelected ? '2px solid ' + B.night : 'none',
                                opacity: d.value > 0 ? 1 : 0.6,
                                borderRadius: '6px 6px 0 0',
                                cursor: 'pointer',
                                padding: 0
                              }}
                              title={chartMetric === 'steps' ? d.value.toLocaleString() + ' steps' : d.value.toFixed(1) + ' km'}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                      {data.map(d => (
                        <div key={'label-' + d.dayNumber} style={{ flex: 1, minWidth: 24, maxWidth: 48, textAlign: 'center', fontSize: 11, color: selectedDay === d.dayNumber ? B.forest : B.muted, fontWeight: selectedDay === d.dayNumber ? 700 : 500 }}>
                          D{d.dayNumber}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, overflowX: 'auto' }}>
        {Array.from({ length: totalDays }, (_, i) => i + 1).map(dn => {
          const hl = dayLogs.find(l => l.dayNumber === dn && (l.steps || l.distance || l.notes));
          return (
            <button
              key={dn}
              onClick={() => setSelectedDay(dn)}
              style={{
                padding: '10px 16px',
                borderRadius: 50,
                border: 'none',
                background: selectedDay === dn ? B.forest : hl ? '#e8f5e9' : '#f0f0f0',
                color: selectedDay === dn ? 'white' : hl ? B.forest : B.night,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 13,
                whiteSpace: 'nowrap'
              }}
            >
              Day {dn}
            </button>
          );
        })}
      </div>
      <div style={{ background: '#fafafa', borderRadius: 12, padding: 20 }}>
        <h4 style={{ marginBottom: 16 }}>Day {selectedDay} Log</h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 12, fontWeight: 600 }}>👣 Steps</label>
            <Input
              type="number"
              placeholder="e.g. 10000"
              value={logForm.steps}
              onChange={e => setLogForm({ ...logForm, steps: e.target.value })} />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 12, fontWeight: 600 }}>📏 Distance (km)</label>
            <Input
              type="number"
              step="0.1"
              placeholder="e.g. 7.5"
              value={logForm.distance}
              onChange={e => setLogForm({ ...logForm, distance: e.target.value })} />
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontSize: 12, fontWeight: 600 }}>📝 Notes</label>
          <textarea
            placeholder="What did you do today?"
            value={logForm.notes}
            onChange={e => setLogForm({ ...logForm, notes: e.target.value })}
            style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #ddd', minHeight: 80 }}
          />
        </div>
        <button
          onClick={onSaveLog}
          disabled={savingLog}
          style={{
            width: '100%',
            padding: 14,
            background: B.forest,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            cursor: savingLog ? 'not-allowed' : 'pointer',
            fontWeight: 700
          }}
        >
          {savingLog ? 'Saving...' : '💾 Save Day Log'}
        </button>
        {selectedLog?.photos?.length >= 3 && (
          <button
            onClick={() => handleCreateReel(selectedLog)}
            style={{
              width: '100%',
              padding: 14,
              background: B.amber,
              color: B.night,
              border: 'none',
              borderRadius: 12,
              cursor: 'pointer',
              fontWeight: 700,
              marginTop: 8
            }}
          >
            🎬 Create Recap Reel
          </button>
        )}
      </div>
    </div>
  );
}